import { CustomFieldOption } from '@he-novation/config/types/custom-field.types';
import Chips, { ChipsProps } from '@he-novation/design-system/components/widgets/Chips/Chips';
import { hexToRgb } from '@he-novation/utils/colors';
import cn from 'classnames';

type TaskLabelChipsProps = {
    taskLabel: CustomFieldOption;
} & Omit<ChipsProps, 'children' | 'color' | 'background'>;

export function TaskLabelChips({ taskLabel, ...props }: TaskLabelChipsProps) {
    return (
        <Chips
            color={taskLabel.color || undefined}
            background={`rgba(${hexToRgb(taskLabel.color || '#FFFFFF')}, 0.20)`}
            {...props}
        >
            <span
                className={cn(
                    'font-semibold',
                    'normal-case',
                    'overflow-hidden',
                    'text-ellipsis',
                    'text-nowrap',
                    'text-sm'
                )}
            >
                {taskLabel.label}
            </span>
        </Chips>
    );
}
